export default __webpack_public_path__ + "static/union-pay-e43ccba32fb534a81a76a704c00d3b95.svg";